import * as Types from '../types.generated'

import { gql } from '@apollo/client'
export const OrganizationsListItemFragmentDoc = gql`
  fragment OrganizationsListItem on Organization {
    id
    name
    description
    slug
    logo {
      url
      isBright
    }
  }
`
export type OrganizationsListItemFragment = {
  __typename?: 'Organization'
  id: string
  name: string
  description: string
  slug: string
  logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
}
